/* LOTE C (02/11/2026): código em uso de snippets/custom-code-pixph.liquid. O <script> que continua dentro do snippet NÃO vai mais
   para a página (custom-code-cardpadrao.liquid só usa a parte de estilo do snippet). Alterações: editar ESTE arquivo. */
  (function() {
    if (window.__srfPixPh) return;
    window.__srfPixPh = true;

    /* 1) Lugar reservado do botão do Pix na gaveta */
    var since = 0;
    function scalaReady(box) {
      var s = box.querySelector('scala-cart-button');
      if (!s) return false;
      var r = s.getBoundingClientRect();
      if (r.height < 20) return false;
      return getComputedStyle(s).visibility !== 'hidden';
    }
    function clearPh(dr) {
      Array.prototype.forEach.call(dr.querySelectorAll('.srf-pix-ph'), function(el) { el.remove(); });
      var sc = dr.querySelector('scala-cart-button');
      Array.prototype.forEach.call(dr.querySelectorAll('.srf-pix-hint-ph'), function(el) {
        if (sc) el.classList.remove('srf-pix-hint-ph'); else el.remove();
      });
    }
    function tick() {
      var dr = document.getElementById('cart-drawer-container');
      if (!dr) return;
      var open = dr.getBoundingClientRect().width > 40;
      var form = dr.querySelector('.checkout-form');
      var box = form && form.parentElement;
      var ph = dr.querySelector('.srf-pix-ph');
      if (!open || !box) { since = 0; clearPh(dr); return; }
      if (scalaReady(box)) { clearPh(dr); return; }
      if (!since) since = Date.now();
      if (Date.now() - since > 5000) { clearPh(dr); return; }
      if (!ph) {
        ph = document.createElement('div');
        ph.className = 'srf-pix-ph';
        ph.setAttribute('aria-hidden', 'true');
        ph.innerHTML = '<i></i><span>Finalizar no Pix</span>';
        var s = box.querySelector('scala-cart-button');
        box.insertBefore(ph, s || form);
        fast();
      }
      var co = dr.querySelector('.scd__checkout[name="checkout"]');
      if (co && !dr.querySelector('.srf-pix-hint') && !dr.querySelector('.srf-pix-hint-ph')) {
        var h = document.createElement('p');
        h.className = 'srf-pix-hint srf-pix-hint-ph';
        h.innerHTML = 'Desconto de <strong>5% no Pix</strong> só pelo botão Pix.';
        co.parentNode.insertBefore(h, co.nextSibling);
      }
      var real = dr.querySelectorAll('.srf-pix-hint:not(.srf-pix-hint-ph)').length;
      if (real) Array.prototype.forEach.call(dr.querySelectorAll('.srf-pix-hint-ph'), function(el) { el.remove(); });
    }
    var raf = 0;
    function fast() {
      if (raf) return;
      (function loop() {
        var dr = document.getElementById('cart-drawer-container');
        if (!dr || !dr.querySelector('.srf-pix-ph')) { raf = 0; return; }
        tick();
        raf = requestAnimationFrame(loop);
      })();
    }
    setInterval(tick, 60);

    /* 2) "Adicionando…" na hora do toque na compra rápida */
    document.addEventListener('click', function(e) {
      if (!e.isTrusted) return;
      var b = e.target.closest && e.target.closest('.srf-qv2 .add-to-cart');
      if (!b) return;
      setTimeout(function() {
        var root = b.closest('.srf-qv2');
        if (!root || root.classList.contains('srf-nosize') || b.disabled) return;
        var lab = b.querySelector('span:not(.atc-spinner)') || b;
        if (!b.__srfTxt) b.__srfTxt = lab.textContent;
        lab.textContent = 'Adicionando…';
        b.classList.add('srf-adding');
        var t0 = Date.now();
        var iv = setInterval(function() {
          var gone = b.getBoundingClientRect().width === 0;
          if (gone || Date.now() - t0 > 6000) {
            clearInterval(iv);
            b.classList.remove('srf-adding');
            if (lab.textContent === 'Adicionando…') lab.textContent = b.__srfTxt;
          }
        }, 150);
      }, 0);
    }, false);
    /* 3) Gaveta abre assim que o item é confirmado (buscas em paralelo) */
    function patchAdded() {
      var S = window.Shopify;
      if (!S || typeof S.onItemAdded !== 'function' || S.onItemAdded.__srf) return !!(S && S.onItemAdded && S.onItemAdded.__srf);
      var orig = S.onItemAdded;
      var fn = async function(item, open) {
        if (open === undefined) open = true;
        var T = window.spratlyTheme || {}, C = T.Cart, N = T.Notification;
        if (!open || !C || typeof C.refreshCart !== 'function' || typeof C.renderNewCart !== 'function' || typeof C.openCartDrawer !== 'function') {
          return orig.apply(this, arguments);
        }
        var root = document.documentElement;
        var opt = root.classList.contains('srf-cart-opt');
        try {
          var ev = window._ThemeEvent; if (ev && ev.emit) ev.emit('ON_ITEM_ADDED', item);
          if (!opt) root.classList.add('srf-cart-loading');
          try { C.openCartDrawer(); } catch (x) {}
          await Promise.all([C.refreshCart(), C.renderNewCart()]);
          try { if (typeof S.onCartUpdate === 'function') S.onCartUpdate(C.cart, false); } catch (x) {}
          root.classList.remove('srf-cart-loading');
          try { C.openCartDrawer(); } catch (x) {}
          optDone();
          try { document.dispatchEvent(new CustomEvent('srf:cart-rendered')); } catch (x) {}
          /* (02/11 16h) sem o aviso verde "Produto adicionado": a gaveta aberta com a peça já mostra que entrou */
        } catch (err) {
          root.classList.remove('srf-cart-loading');
          optDone();
          try { return orig.call(this, item, open); } catch (x) {}
        }
      };
      fn.__srf = true;
      S.onItemAdded = fn;
      return true;
    }
    if (!patchAdded()) { var pn = 0, piv = setInterval(function() { pn++; if (patchAdded() || pn > 100) clearInterval(piv); }, 100); }
    setInterval(patchAdded, 1000);

    /* 5) Gaveta instantânea: no toque, a compra rápida fecha e a gaveta abre JÁ com a peça (montada com os dados da
          compra rápida). A Shopify leva ~1,2–1,4 s para confirmar (descontos dos kits/Pix rodando no servidor); nesse
          meio-tempo só os botões de finalizar ficam esperando. Quando confirma, a gaveta é trocada pela real.
          Se a Shopify recusar (ex.: sem estoque), a peça some da gaveta e aparece o aviso do motivo. */
    var optTimer = 0, emptyEl = null;
    function optDone() {
      clearTimeout(optTimer);
      document.documentElement.classList.remove('srf-cart-opt', 'srf-opt-empty');
      Array.prototype.forEach.call(document.querySelectorAll('#cart-drawer-container .srf-opt'), function(el) { el.remove(); });
      if (emptyEl) {
        var bd = document.querySelector('#cart-drawer-container .scd__body');
        if (bd && !bd.querySelector('.scd__items') && !bd.querySelector('.scd-empty-msg')) bd.insertBefore(emptyEl, bd.firstChild);
        emptyEl = null;
      }
      Array.prototype.forEach.call(document.querySelectorAll('#cart-drawer-container .srf-opt-hide'), function(el) { el.classList.remove('srf-opt-hide'); });
      Array.prototype.forEach.call(document.querySelectorAll('#cart-drawer-container .srf-opt-qty'), function(el) {
        if (el.__srfOld != null) el.value = el.__srfOld; el.classList.remove('srf-opt-qty');
      });
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    /* dados da peça: compra rápida (.srf-qv2) ou página do produto (.main-product__blocks) */
    function pageRoot() { return document.querySelector('.main-product__blocks'); }
    function pageForm() { var r = pageRoot(); return r && (r.closest('form[action*="/cart/add"]') || r.querySelector('form[action*="/cart/add"]')); }
    function pageSingle() {
      /* só 1 peça: sem Kaching, ou Kaching com a opção "1 ..." marcada */
      var sel = document.querySelector('.kaching-bundles__bar--selected');
      if (!sel) return !document.querySelector('.kaching-bundles__bar');
      var t = sel.querySelector('.kaching-bundles__bar-title');
      return !!t && /^\s*1\s/.test(t.textContent);
    }
    function pageReady() {
      var f = pageForm(); if (!f) return false;
      var idIn = f.querySelector('[name="id"]'); if (!idIn || !idIn.value) return false;
      var main = f.querySelector('.add-to-cart');
      if (main && (main.disabled || main.getAttribute('aria-disabled') === 'true')) return false;
      var opts = pageRoot().querySelectorAll('.product-options__option[data-product-option]');
      for (var i = 0; i < opts.length; i++) if (!opts[i].querySelector('[data-selected="true"]')) return false;
      return pageSingle();
    }
    function optimistic(b) {
      var T = window.spratlyTheme || {}, C = T.Cart, N = T.Notification;
      if (!C || typeof C.openCartDrawer !== 'function' || C.isCartPage) return false;
      var qv = b.closest('.srf-qv2');
      var root = qv || pageRoot(); if (!root) return false;
      var form = qv ? (b.closest('form') || root.querySelector('form[action*="/cart/add"]')) : pageForm();
      var idIn = form && form.querySelector('[name="id"]'); var vid = idIn && idIn.value; if (!vid) return false;
      var dr = document.getElementById('cart-drawer-container'); if (!dr) return false;
      var body = dr.querySelector('.scd__body'); if (!body) return false;
      var a, title, url, img, src, pe, price;
      if (qv) {
        a = root.querySelector('.prod__title a'); title = (a || root.querySelector('.prod__title') || {}).textContent || '';
        url = a ? a.getAttribute('href') : '#';
        img = root.querySelector('.srf-qvg__slide:not([hidden]) img');
        src = img ? (img.currentSrc || img.src) : '';
        pe = root.querySelector('.srf-qv2__price .prod__price');
      } else {
        title = (root.querySelector('.main-product__block-title h1') || {}).textContent || document.title;
        url = location.pathname;
        /* foto da galeria (slide ativo no celular, 1ª foto no computador); nunca os ícones de pagamento/Kaching */
        img = document.querySelector('.swiper-slide-active .sf-prod-media-item img, .swiper-slide-active .sf-prod-media img') ||
          document.querySelector('.sf-prod-media-item.media-type-image img, .sf-prod-media img');
        src = img ? (img.currentSrc || img.src || String(img.getAttribute('data-src') || '').replace('{width}', '360')) : '';
        if (!src) src = (document.querySelector('meta[property="og:image"]') || {}).content || '';
        pe = root.querySelector('.main-product__block-price .prod__price') || root.querySelector('.prod__price');
      }
      price = pe ? pe.textContent.trim() : '';
      var opts = '';
      Array.prototype.forEach.call(root.querySelectorAll('.product-options__option[data-product-option]'), function(o) {
        var s = o.querySelector('[data-selected="true"]'); if (!s) return;
        opts += '<p class="scd-item__variant-option"><span>' + esc(o.getAttribute('data-product-option')) + ': </span>' + esc(s.getAttribute('data-value')) + '</p>';
      });
      var items = body.querySelector('.scd__items');
      if (!items) {
        items = document.createElement('div'); items.className = 'scd__items srf-opt';
        body.insertBefore(items, body.firstChild);
        /* carrinho vazio: a mensagem de vazio esconde a barra de frete e o rodapé e centraliza a gaveta (regras :has).
           Sai da página enquanto a peça é confirmada; volta se a Shopify recusar. */
        var em = body.querySelector('.scd-empty-msg');
        if (em) { emptyEl = em; em.remove(); document.documentElement.classList.add('srf-opt-empty'); }
      }
      var same = items.querySelector('.scd-item[data-id^="' + vid + ':"] .scd-item__qty_input');
      if (same) {
        same.__srfOld = same.value; same.value = (parseInt(same.value, 10) || 0) + 1; same.classList.add('srf-opt-qty');
        var row = same.closest('.scd-item'); if (row && row !== items.firstElementChild) items.insertBefore(row, items.firstElementChild);
      } else {
        var el = document.createElement('div');
        el.className = 'scd-item srf-opt';
        el.innerHTML = '<div class="scd-item__inner flex items-start"><div class="scd-item__image"><a href="' + esc(url) + '" class="block" style="--aspect-ratio:1.0">' +
          (src ? '<img src="' + esc(src) + '" alt="">' : '') + '</a></div><div class="scd-item__info"><a href="' + esc(url) + '" class="font-medium hover:underline">' + esc(title.trim()) +
          '</a><div class="scd-item__variant mb-0.5 flex">' + opts + '</div><div class="scd-item__prices"><span class="scd-item__price sf-currency text-color-regular-price">' + esc(price) +
          '</span></div><div class="flex items-center mt-[10px]"><div class="scd-item__quantity flex justify-between rounded"><button class="scd-item__btn" type="button" tabindex="-1">-</button>' +
          '<input class="py-1 scd-item__qty_input w-9 text-center" type="number" value="1" readonly tabindex="-1"><button class="scd-item__btn" type="button" tabindex="-1">+</button></div></div></div></div>';
        items.insertBefore(el, items.firstChild);
      }
      /* carrinho estava vazio: a barra de frete grátis já mostra o valor desta peça (frete grátis acima de R$ 299) */
      var fsb = document.documentElement.classList.contains('srf-opt-empty') && dr.querySelector('.scd__header .free-shipping-bar');
      if (fsb) {
        var pm = String(price).match(/(\d{1,3}(?:\.\d{3})*),(\d{2})/);
        var cents = pm ? parseInt(pm[1].replace(/\./g, ''), 10) * 100 + parseInt(pm[2], 10) : 0;
        var falta = 29900 - cents, pct = Math.max(0, Math.min(100, Math.round(cents / 299)));
        var msg = fsb.querySelector('.free-shipping-bar__message'), fill = fsb.querySelector('.free-shipping-bar__fill');
        if (msg) msg.innerHTML = falta > 0 ? 'Falta <strong>R$ ' + (falta / 100).toFixed(2).replace('.', ',') + '</strong> para frete grátis!' : '🎉 Você ganhou frete grátis!';
        if (fill) fill.style.width = pct + '%';
      }
      document.documentElement.classList.add('srf-cart-opt');
      optClickAt = Date.now();
      try { if (window.__srfPrefetchRecs) window.__srfPrefetchRecs(qv ? null : (window.meta && window.meta.product && window.meta.product.id)); } catch (e) {}
      if (qv) {
        /* 8) (02/11) fecha a compra rápida ANTES de abrir a gaveta. Antes abria a gaveta com a compra rápida ainda aberta
              e fechava em seguida: no Safari o fundo escuro da compra rápida ficava desenhado por cima da gaveta até o
              cliente clicar na tela (1ª peça, carrinho vazio). Quando a janela sai da página, a gaveta é aberta de novo
              (trava a rolagem no celular, que o fechamento da janela soltava) e redesenhada. Se a janela não sair em 1 s,
              é retirada. */
        var wrapM = root.closest('.sf-modal__wrapper, .sf-modal');
        var m = root.closest('.sf-modal, [class*="modal"]');
        var x = (m && m.querySelector('.sf-modal__close')) || document.querySelector('.sf-modal__close');
        /* no próximo instante: o tema já começou a adicionar com o formulário da janela */
        setTimeout(function() {
          if (x) { x.__srfPass = true; try { x.click(); } catch (e) {} x.__srfPass = false; }
          try { C.openCartDrawer(); } catch (e) {}
        }, 0);
        var mn = 0, miv = setInterval(function() {
          mn++;
          var still = wrapM && wrapM.isConnected && getComputedStyle(wrapM).display !== 'none';
          if (still && mn < 20) return;
          clearInterval(miv);
          if (still) { try { wrapM.remove(); } catch (e) {} document.body.classList.remove('srf-qv-open'); }
          var w = dr.querySelector('.scd__wrapper');
          if (!w || w.classList.contains('hidden')) return; /* cliente já fechou a gaveta */
          try { C.openCartDrawer(); } catch (e) {}
          requestAnimationFrame(function() { w.style.outline = '1px solid transparent'; void w.offsetHeight; requestAnimationFrame(function() { w.style.outline = ''; }); });
        }, 50);
      } else {
        try { C.openCartDrawer(); } catch (e) {}
        /* página do produto: o tema usa um fetch guardado antes deste script, então o pedido de adicionar é acompanhado
           pela lista de recursos do navegador. Se ele terminar e a gaveta real não vier em 2,5 s (recusado: sem estoque
           etc.), a peça provisória sai e a gaveta real é desenhada (o tema mostra o aviso dele). */
        try {
          var t0 = performance.now();
          var po = new PerformanceObserver(function(list) {
            list.getEntries().forEach(function(en) {
              if (en.startTime < t0 - 50 || !/\/cart\/add/.test(en.name)) return;
              po.disconnect();
              setTimeout(function() {
                if (!document.documentElement.classList.contains('srf-cart-opt')) return;
                optDone();
                try { Promise.all([C.refreshCart(), C.renderNewCart()]); } catch (e) {}
              }, 2500);
            });
          });
          po.observe({ type: 'resource', buffered: false });
          setTimeout(function() { try { po.disconnect(); } catch (e) {} }, 9000);
        } catch (e) {}
      }
      optTimer = setTimeout(function() {
        if (!document.documentElement.classList.contains('srf-cart-opt')) return;
        optDone();
        try { Promise.all([C.refreshCart(), C.renderNewCart()]); } catch (e) {}
      }, 9000);
      return true;
    }
    var optClickAt = 0, addSeenAt = 0;
    document.addEventListener('click', function(e) {
      if (!e.isTrusted) return;
      if (document.documentElement.classList.contains('srf-cart-opt')) return;
      var b = e.target.closest && e.target.closest('.srf-qv2 .add-to-cart');
      if (b) {
        var root = b.closest('.srf-qv2');
        if (!root || root.classList.contains('srf-nosize') || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
        try { optimistic(b); } catch (err) { optDone(); }
        return;
      }
      /* 7a) página do produto: botão principal ou botão fixo do celular */
      var pb = e.target.closest && e.target.closest('.main-product__blocks .add-to-cart, #srf-sticky-atc button');
      if (!pb || pb.disabled || pb.classList.contains('is-loading')) return;
      if (!pageReady()) return;
      try { optimistic(pb); } catch (err) { optDone(); }
    }, false);
    /* resposta da Shopify: se recusar, desfaz e mostra o motivo na gaveta */
    if (!window.__srfOptFetch) {
      window.__srfOptFetch = true;
      var of = window.fetch;
      /* 6) Compra rápida abre mais rápido: a janela da compra rápida (~60 KB, ~0,4 s no wi-fi, 1 s+ no 4G) começa a ser
            baixada quando o mouse para sobre o card (computador) ou no primeiro toque no botão (celular), antes do clique
            terminar. Quando o tema pede a janela, recebe a que já foi baixada. Só baixa o card que o cliente está mirando. */
      var qvCache = {};
      function qvPrefetch(card) {
        var btn = card && card.querySelector && card.querySelector('.sf-pqv__button[data-product-handle]');
        var h = btn && btn.getAttribute('data-product-handle'); if (!h) return;
        var u = '/products/' + h + '?view=quickview';
        if (qvCache[u]) return;
        qvCache[u] = of.call(window, u, { credentials: 'same-origin' }).then(function(r) { if (!r.ok) throw new Error('qv'); return r.text(); })
          .catch(function() { delete qvCache[u]; return null; });
      }
      var hovT = 0, hovCard = null;
      document.addEventListener('mouseover', function(e) {
        var c = e.target && e.target.closest && e.target.closest('.sf__pcard');
        if (!c || c === hovCard) return;
        hovCard = c; clearTimeout(hovT);
        hovT = setTimeout(function() { qvPrefetch(c); }, 120);
      }, { passive: true });
      document.addEventListener('touchstart', function(e) {
        var b = e.target && e.target.closest && e.target.closest('.srf-qb, .sf-pqv__button');
        if (b) qvPrefetch(b.closest('.sf__pcard') || b.parentElement);
      }, { passive: true, capture: true });
      /* 7b/7c) gaveta pronta junto com o adicionar, carrinho reaproveitado e memória curta de recomendações/produtos */
      var SEC = 'cart-drawer', secCache = null, snap = null, mutIn = 0, mutEnd = 0, memo = {};
      var MUT_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/, CART_RE = /^\/cart\.(js|json)(\?|$)/;
      var MEMO_RE = /^\/(recommendations\/products\.json\?|products\/[^\/?#]+\.js(\?|$))/;
      function pathOf(url) { try { var x = new URL(url, location.href); return x.origin === location.origin ? x.pathname + x.search : ''; } catch (e) { return ''; } }
      function withSections(init) {
        try {
          var bd = init && init.body;
          if (typeof bd === 'string') {
            var j = JSON.parse(bd);
            if (!j || typeof j !== 'object') return init;
            var cur = j.sections ? (Array.isArray(j.sections) ? j.sections.join(',') : String(j.sections)) : '';
            if (cur.split(',').indexOf(SEC) < 0) j.sections = cur ? cur + ',' + SEC : SEC;
            if (!j.sections_url) j.sections_url = location.pathname;
            var ni = {}; for (var k in init) ni[k] = init[k]; ni.body = JSON.stringify(j); return ni;
          }
          if (bd && typeof FormData !== 'undefined' && bd instanceof FormData) {
            var cs = bd.get('sections');
            if (!cs) bd.set('sections', SEC); else if (String(cs).split(',').indexOf(SEC) < 0) bd.set('sections', cs + ',' + SEC);
            if (!bd.get('sections_url')) bd.set('sections_url', location.pathname);
          }
        } catch (e) {}
        return init;
      }
      function memoGet(path, self, args) {
        var m = memo[path];
        if (m && Date.now() - m.at < 60000) return m.p.then(function(t) { return t == null ? of.apply(self, args) : new Response(t, { status: 200, headers: { 'Content-Type': 'application/json' } }); });
        var p = of.apply(self, args);
        memo[path] = { at: Date.now(), p: p.then(function(r) { return r.ok ? r.clone().text() : null; }).catch(function() { return null; }) };
        memo[path].p.then(function(t) { if (t == null) delete memo[path]; });
        return p;
      }
      function prefetchFor(pid) {
        if (!pid) return;
        var u = '/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related';
        if (memo[u] && Date.now() - memo[u].at < 60000) return;
        memoGet(u, window, [u]);
      }
      window.__srfPrefetchRecs = prefetchFor;
      /* alterações do carrinho feitas por XMLHttpRequest também invalidam o carrinho guardado */
      try {
        var XP = XMLHttpRequest.prototype, xo2 = XP.open, xs2 = XP.send;
        XP.open = function(m, u) { try { this.__srfMut = String(m || 'GET').toUpperCase() === 'POST' && MUT_RE.test(pathOf(String(u || ''))); this.__srfAddX = this.__srfMut && /\/cart\/add/.test(String(u)); } catch (e) {} return xo2.apply(this, arguments); };
        XP.send = function() {
          if (this.__srfMut) {
            snap = null; secCache = null; mutIn++; if (this.__srfAddX) addSeenAt = Date.now();
            this.addEventListener('loadend', function() { mutIn = Math.max(0, mutIn - 1); mutEnd = Date.now(); });
          }
          return xs2.apply(this, arguments);
        };
      } catch (e) {}
      window.fetch = function(u, init) {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        var self = this, args = arguments;
        var method = String((init && init.method) || (u && u.method) || 'GET').toUpperCase();
        var path = pathOf(url);
        try {
          if (path && method === 'GET') {
            /* gaveta pedida logo depois do adicionar: entrega a que veio junto */
            if (/[?&]section_id=cart-drawer(&|$)/.test(path) && secCache && !mutIn && secCache.at >= mutEnd && Date.now() - secCache.at < 4000) {
              var h = secCache.html; secCache = null;
              return Promise.resolve(new Response(h, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } }));
            }
            if (CART_RE.test(path)) {
              if (snap && !mutIn && snap.at >= mutEnd && Date.now() - snap.at < 1500) {
                var sp = snap.p;
                return sp.then(function(t) { return t == null ? of.apply(self, args) : new Response(t, { status: 200, headers: { 'Content-Type': 'application/json' } }); });
              }
              if (!mutIn) {
                var startAt = Date.now();
                var cp = of.apply(this, arguments);
                var tp = cp.then(function(r) { return r.ok ? r.clone().text() : null; }).catch(function() { return null; });
                tp.then(function(t) { if (t != null && !mutIn && startAt >= mutEnd) snap = { at: Date.now(), p: Promise.resolve(t) }; });
                return cp;
              }
            }
            if (MEMO_RE.test(path)) return memoGet(path, this, arguments);
          }
          if (path && method === 'POST' && MUT_RE.test(path)) {
            snap = null; secCache = null; mutIn++;
            var isAdd = /\/cart\/add/.test(path);
            if (isAdd) { addSeenAt = Date.now(); if (typeof u === 'string') { init = withSections(init); args = [u, init]; } }
            var mp = of.apply(this, args);
            mp.then(function(r) {
              mutIn = Math.max(0, mutIn - 1); mutEnd = Date.now();
              if (isAdd && r && r.ok) r.clone().json().then(function(j) { var sh = j && j.sections && j.sections[SEC]; if (sh) secCache = { at: Date.now(), html: sh }; }).catch(function() {});
            }, function() { mutIn = Math.max(0, mutIn - 1); mutEnd = Date.now(); });
            if (isAdd) watchAdd(mp);
            return mp;
          }
        } catch (e) {}
        if (qvCache[url]) {
          return qvCache[url].then(function(t) {
            if (t == null) return of.apply(self, args);
            return new Response(t, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
          });
        }
        var p = of.apply(this, arguments);
        if (url.indexOf('/cart/add') > -1) watchAdd(p);
        return p;
      };
      function watchAdd(p) {
          p.then(function(r) {
            if (r.ok || !document.documentElement.classList.contains('srf-cart-opt')) return;
            r.clone().json().catch(function() { return {}; }).then(function(j) {
              optDone();
              var T = window.spratlyTheme || {}, N = T.Notification;
              var it = document.querySelector('#cart-drawer-container .scd__items') || document.querySelector('#cart-drawer-container .scd__body');
              if (N && N.show && it) N.show({ target: it, method: 'prepend', type: 'warning', last: 6000,
                message: (j && (j.description || j.message)) || 'Não foi possível adicionar. Tente de novo.' });
            });
          }, function() { if (document.documentElement.classList.contains('srf-cart-opt')) optDone(); });
      }
    }

  })();
